__webpack_require__.i.push((options) => {
	const originalFactory = options.factory;
	options.factory = (moduleObject, moduleExports, webpackRequire) => {
		const hasRefresh = typeof self !== "undefined" && !!self.$RefreshInterceptModuleExecution$;
		const cleanup = hasRefresh ? self.$RefreshInterceptModuleExecution$(moduleObject.id) : () => {};
		try {
			originalFactory.call(this, moduleObject, moduleExports, webpackRequire);
		} finally {
			cleanup();
		}
	}
})